// extracted by mini-css-extract-plugin
export default {"link":"DCLink_link_CC93m"};